export enum ANIMATION_MODE {
    HORIZONTAL_SLIDE = 'HORIZONTAL_SLIDE',
    VERTICAL_SLIDE = 'VERTICAL_SLIDE',
    FADE_IN = 'FADE_IN',
}
